import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { channelsPlaylistsList_template } from "../components/templates/channelsPlaylistsList_template";
import { header } from "./header";

declare const ko: any;
declare const page: any;

export class channels_playlists extends vnModule_knockoutJS {
    protected idBrand: number;
    protected listTemplate: channelsPlaylistsList_template;
    protected pagination: pagination_template;
    protected timer: number;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    protected ApiUrls: any = {
        playlistAdd: `/brand/${this.getVnAppZone().app.params.idBrand}/categorization/playlists/add`,
        playlistEdit: `/brand/${this.getVnAppZone().app.params.idBrand}/categorization/playlists/edit`,
        playlistsGet: `/api/brand/${this.getVnAppZone().app.params.idBrand}/channels/playlists/get`,
        playlistView: `/brand/${this.getVnAppZone().app.params.idBrand}/categorization/playlists/view`,
        presetDelete: `/api/search_preset/delete`,
        presetFavoriteSave: `/api/search_preset/favorite/save`,
        presetGet: `/api/search_preset/get`,
        presetSave: `/api/search_preset/save`,
        referencesGet: `/api/brand/${this.getVnAppZone().app.params.idBrand}/channels/playlists/references`,
        channelsSuggestionsGet: `/api/brand/${this.getVnAppZone().app.params.idBrand}/channels/search/`,
    };

    protected getModuleName() {
        return "channels_playlists";
    }

    public buildContent(): Array<Element> {
        this.idBrand = this.getVnAppZone().app.params.idBrand;
        this.listTemplate = new channelsPlaylistsList_template("list", this.viewModel, this);
        this.template = this.listTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Playlists");

        return [this.listTemplate.build()];
    }

    public fillPage(): void {
        this.listTemplate.buildDatePickerCalendar();
        this.getReferences();
    }

    protected getReferences() {
        this.XHRHdl = new XMLHttpRequestHandler(this.ApiUrls.referencesGet, [], this);
        this.XHRHdl.onReadyStateFunction = this.onGetReferences;
        this.XHRHdl.execute();
    }

    protected onGetReferences(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.listTemplate.setAvailableForUseFilter(responseParsed.availableForUse);
                obj.getData();
            });
        };
    }

    protected getData() {
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterList() {
        this.filterSimpleCancel();
        this.loadingIn(this.listTemplate.builtTemplate.children.namedItem("list-results"));
        this.timer = new Date().getTime();
        this.sendFilterCall(
            this.ApiUrls.playlistsGet,
            this.listTemplate.getViewModelForRequest(),
            this.onFilterList,
            XMLHttpRequestHandler_requestType.GET,
            "playlists",
            this.listTemplate.builtTemplate.children.namedItem("list-results"),
        );
    }

    protected onFilterList(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.listTemplate.setIdBrand(obj.getVnAppZone().app.params.idBrand);
                obj.listTemplate.setPlaylists(responseParsed.data);
                obj.listTemplate.setResultInfo(
                    responseParsed.totalCount,
                    responseParsed.totalPage,
                    Math.round(((new Date().getTime() - obj.timer) / 1000) * 100) / 100,
                );
                obj.viewModel.list.pagination.itemCount(responseParsed.totalCount);
                obj.updateViewModelFromPath();
                obj.getSearchPresets();
            });
            obj.loadingOut(obj.listTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    protected filterByUrl() {
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters) {
        this.listTemplate.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected filterDateOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(idElement) {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected playlistsListReorder() {
        this.filterList();
    }

    protected getMemoryViewModel() {
        let templateViewModel = this.listTemplate.getTemplateViewModel();
        delete templateViewModel.playlists;
        return templateViewModel;
    }

    protected addPlaylist() {
        this.filterSimpleCancel();
        this.saveViewModule(this.getMemoryViewModel());
        page(this.ApiUrls.playlistAdd);
    }

    protected viewPlaylist(id) {
        this.saveViewModule(this.getMemoryViewModel());
        let viewUrl = `${window.location.origin}${this.ApiUrls.playlistView}/${id}`;
        let editUrl = `${window.location.origin}${this.ApiUrls.playlistEdit}/${id}`;
        this.savePreviousPage(viewUrl, window.location.href);
        this.savePreviousPage(editUrl, window.location.href);
        page(`${this.ApiUrls.playlistView}/${id}`);
    }

    protected getSearchPresets(): void {
        this.cancelRequest("getSearchPresets");
        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getSearchPresets"] = new XMLHttpRequestHandler(this.ApiUrls.presetGet, usrReq_params, this);
        this.XHRHdls["getSearchPresets"].onReadyStateFunction = this.onGetSearchPresets;
        this.XHRHdls["getSearchPresets"].execute();
    }

    protected onGetSearchPresets(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.setSearchPresets(response);
            });
        };
    }

    protected saveSearchPreset() {
        this.cancelRequest("saveSearchPreset");
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["saveSearchPreset"] = new XMLHttpRequestHandler(this.ApiUrls.presetSave, formReq_params, this);
        this.XHRHdls["saveSearchPreset"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["saveSearchPreset"].onReadyStateFunction = this.onSaveSearchPreset;
        this.XHRHdls["saveSearchPreset"].execute();
    }

    private onSaveSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected saveFavoriteSearchPreset(params: { presetId: number; searchPresetType: string }): void {
        this.cancelRequest("saveFavoriteSearchPreset");
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(params));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["saveFavoriteSearchPreset"] = new XMLHttpRequestHandler(
            this.ApiUrls.presetFavoriteSave,
            formReq_params,
            this,
        );
        this.XHRHdls["saveFavoriteSearchPreset"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["saveFavoriteSearchPreset"].onReadyStateFunction = this.onSearchPreset;
        this.XHRHdls["saveFavoriteSearchPreset"].execute();
    }

    private onSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected deleteSearchPreset(presetId: number): void {
        this.cancelRequest("deleteSearchPreset");
        let usrReq_url: string = `${this.ApiUrls.presetDelete}/${presetId}/`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls["deleteSearchPreset"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["deleteSearchPreset"].onReadyStateFunction = this.onSearchPreset;
        this.XHRHdls["deleteSearchPreset"].execute();
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) this.XHRHdl.cancelAndReset();
    }

    protected cancelRequest(requestName) {
        if (this.XHRHdls !== undefined && this.XHRHdls[requestName] !== undefined) {
            this.XHRHdls[requestName].cancelAndReset();
        }
    }

    protected setDefaultStatusFilters() {
        // empty
    }

    protected getTagsSuggestion(keyword, idElement) {
        this.cancelRequest("getChannelsSuggestion");
        let usrReq_url: string = `${this.ApiUrls.channelsSuggestionsGet}`;
        let subViewModel = { filter: { keyword: keyword }, idElement: idElement };
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getChannelsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getChannelsSuggestion"].onReadyStateFunction = this.onGetChannelsSuggestionReturn;
        this.XHRHdls["getChannelsSuggestion"].execute();
    }

    protected onGetChannelsSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data) {
                    obj.listTemplate.setChannelFilter(responseParsed.data);
                }
            });
        };
    }

    protected filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected delete(data) {
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/channels/playlists/delete";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(data)]);
        let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onDelete;
        XHRHdl.execute();
    }

    protected onDelete(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                //console.log(JSON.parse(req.request.response));
                //return;
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "Playlist deleted successfully!",
                );
                page.redirect("/brand/" + obj.getVnAppZone().app.params.idBrand + "/categorization/playlists/");
            });
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/channels_playlists.ts